import { green } from '@ant-design/colors';

export default {
  apiDomain: 'api.reviewsscraper.com',
  homeUrl: 'reviewsscraper.com',
  company: 'Reviewsscraper',
  id: 'reviewsscraper',
  theme: {
    colorPrimary: green[5],
  },
  contactUsUrl: 'https://reviewsscraper.com/contact-us/',
  servicesUrl: 'https://reviewsscraper.com/services/',
  pricingUrl: 'https://reviewsscraper.com/pricing/',
  faqUrl: 'https://reviewsscraper.com/faq/',
  tutorialsUrl: 'https://reviewsscraper.com/category/scraping/tutorials/',
  videosUrl: '',
  communityUrl: null,
  scheduleCallUrl: null,
  termsOfServiceUrl: 'https://reviewsscraper.com/terms-of-service/',
  googleMapsCategoriesUrl: '',
  stripeApiKeys: {
    main: '',
  },
  payPalClientId: '',
  availablePaymentProviders: {
  },
  gaToken: '',
  googleClientId: '42578899751-7ffkqeijnfksskif4lmjvt3hq6h38h5k.apps.googleusercontent.com',
  linkedinClientId: '',
  hubspotClientId: null,
  pipedriveClientId: null,
  zohoClientId: null,
  includedServices: [],
  integrationsLinks: {}
};
